import { extensions, readOnly } from '@yola/ws-sdk';
import LogoResizeTool from '../components/logo-resize-tool';
import config from '../constants/config';

export default {
  matches: (element) => {
    if (readOnly.verifiers.isReadOnlyModeEnabled()) {
      return false;
    }

    const settings = extensions.accessors.getExtensionSettings(config.slug);

    return element.matches(settings.resizeQuerySelector);
  },
  container: LogoResizeTool,
};
